import { Link } from "react-router-dom";
import Logo from "./Logo";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#2C3E45] text-white/85"
        >
            <div className="container-prose py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
                <div>
                    <Logo variant="light" size="lg" />
                    <p className="mt-6 text-sm text-white/65 leading-relaxed max-w-xs">
                        Fiduciaire indépendante à Genève depuis 2004.
                    </p>
                </div>

                <div className="space-y-3">
                    <h3 className="text-white text-sm font-sans font-semibold uppercase tracking-[0.2em] mb-4">
                        Coordonnées
                    </h3>
                    <p className="text-sm text-white font-medium" data-testid="footer-legal-name">
                        Fiduciaire Bleich Sàrl
                    </p>
                    <p className="text-sm text-white/75">Rue de Rive 8, 1204 Genève</p>
                    <p className="text-sm text-white/75">
                        Téléphone :{" "}
                        <a
                            href="tel:+41223193440"
                            data-testid="footer-phone"
                            className="hover:text-white transition-colors"
                        >
                            +41 22 319 34 40
                        </a>
                    </p>
                    <p className="text-sm text-white/75">
                        Email :{" "}
                        <a
                            href="mailto:info@fiduciaire-bleich.ch"
                            data-testid="footer-email"
                            className="hover:text-white transition-colors"
                        >
                            info@fiduciaire-bleich.ch
                        </a>
                    </p>
                    <p className="text-sm text-white/75" data-testid="footer-hours">
                        Horaires : lundi à vendredi, 9h00 à 18h00
                    </p>
                    <div className="pt-3 mt-3 border-t border-white/10 space-y-1.5">
                        <p className="text-xs text-white/65" data-testid="footer-ide">
                            IDE : CHE-112.231.914
                        </p>
                        <p className="text-xs text-white/65" data-testid="footer-founding">
                            Fiduciaire à Genève depuis 2004
                        </p>
                    </div>
                </div>

                <div className="space-y-3">
                    <h3 className="text-white text-sm font-sans font-semibold uppercase tracking-[0.2em] mb-4">
                        Navigation
                    </h3>
                    <ul className="space-y-2">
                        <li>
                            <Link
                                to="/"
                                data-testid="footer-link-accueil"
                                className="text-sm text-white/75 hover:text-white transition-colors"
                            >
                                Accueil
                            </Link>
                        </li>
                        <li>
                            <p className="text-sm text-white/90 font-medium mt-1">Nos services</p>
                            <ul className="mt-2 ml-3 space-y-1.5 border-l border-white/15 pl-3">
                                <li>
                                    <Link
                                        to="/comptabilite"
                                        data-testid="footer-services-comptabilite"
                                        className="text-sm text-white/65 hover:text-white transition-colors"
                                    >
                                        Comptabilité
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/fiscalite"
                                        data-testid="footer-services-fiscalite"
                                        className="text-sm text-white/65 hover:text-white transition-colors"
                                    >
                                        Fiscalité
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/tva"
                                        data-testid="footer-services-tva"
                                        className="text-sm text-white/65 hover:text-white transition-colors"
                                    >
                                        TVA
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/salaires-rh"
                                        data-testid="footer-services-salaires-rh"
                                        className="text-sm text-white/65 hover:text-white transition-colors"
                                    >
                                        Salaires et RH
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/administrateur-gerant"
                                        data-testid="footer-services-administrateur-gerant"
                                        className="text-sm text-white/65 hover:text-white transition-colors"
                                    >
                                        Administrateur et gérant
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/creation-societe"
                                        data-testid="footer-services-creation-societe"
                                        className="text-sm text-white/65 hover:text-white transition-colors"
                                    >
                                        Création de société
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <Link
                                to="/contact"
                                data-testid="footer-link-contact"
                                className="text-sm text-white/75 hover:text-white transition-colors"
                            >
                                Contact
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/mentions-legales"
                                data-testid="footer-link-mentions"
                                className="text-sm text-white/75 hover:text-white transition-colors"
                            >
                                Mentions légales
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/politique-confidentialite"
                                data-testid="footer-link-confidentialite"
                                className="text-sm text-white/75 hover:text-white transition-colors"
                            >
                                Politique de confidentialité
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container-prose py-6 text-xs text-white/55 text-center md:text-left">
                    © 2026 Fiduciaire Bleich Sàrl · IDE CHE-112.231.914 · Tous droits réservés
                </div>
            </div>
        </footer>
    );
};

export default Footer;
